import { Redirect } from 'react-router-dom';
import SharedRoutePath from '../SharedRoutePath';

// NOTE: return URL doesn't appear to be used at all, but it's here in case
export default function ExternalReturn(): JSX.Element {
  return <Redirect to={SharedRoutePath.HOME} />;
}
